import { Helmet } from "react-helmet-async";

export default function Simple({ title, children }) {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-10">
      <Helmet><title>{`${title} · Vyagram`}</title></Helmet>
      <p className="vyg-eyebrow">{title}</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl">{title}</h1>
      <div className="editorial-body mt-8 space-y-4">{children}</div>
    </div>
  );
}
